import { useState } from "react";
import { HrGroupPlace } from "models/hr-dashboard";

// Department view: divisions are subtotal rows that can be collapsed to hide their departments.
export const useCollapsedDivisions = () => {
    const [collapsed, setCollapsed] = useState<Set<string>>(new Set());

    const toggle = (division: string) => setCollapsed(prev => {
        const next = new Set(prev);
        if (next.has(division)) next.delete(division); else next.add(division);
        return next;
    });

    // Subtotal rows are always shown; a department is shown while its division is open
    const isVisible = (g: HrGroupPlace) => g.kind === "subtotal" || !g.division || !collapsed.has(g.division);

    return { collapsed, toggle, isVisible };
};

export const subtotalRowClass = (g: HrGroupPlace) => (g.kind === "subtotal" ? "fw-bold table-light" : undefined);

interface GroupNameCellProps {
    group: HrGroupPlace;
    collapsed: Set<string>;
    toggle: (division: string) => void;
    rowSpan?: number;
}

// Division: bold with an open / close arrow. Department: indented under its division.
export const GroupNameCell = ({ group, collapsed, toggle, rowSpan }: GroupNameCellProps) => {
    if (group.kind === "subtotal") {
        const isOpen = !collapsed.has(group.name);
        return (
            <td rowSpan={rowSpan} className="align-middle fw-bold text-nowrap">
                <button
                    type="button"
                    className="btn btn-link btn-sm p-0 me-1 align-baseline text-reset"
                    onClick={() => toggle(group.name)}
                    title={isOpen ? "Hide departments" : "Show departments"}
                >
                    <i className={`bx ${isOpen ? "bx-chevron-down" : "bx-chevron-right"}`} />
                </button>
                {group.name}
            </td>
        );
    }
    return (
        <td rowSpan={rowSpan} className="align-middle text-nowrap" style={group.division ? { paddingLeft: "1.75rem" } : undefined}>
            {group.name}
        </td>
    );
};
